import React, { useEffect, useState } from 'react';
import { TimerIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34;
export function Countdown() {
  const [left, setLeft] = useState(START_SECONDS);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setLeft(prev => prev <= 0 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units = [{
    label: 'Hours',
    value: Math.floor(left / 3600)
  }, {
    label: 'Min',
    value: Math.floor(left % 3600 / 60)
  }, {
    label: 'Sec',
    value: left % 60
  }];
  return <div className="w-full rounded-2xl bg-ink px-4 py-4 text-white" role="timer" aria-live="off" data-id="element-112" data-mp="323ybyvktpq06">
      <p className="flex items-center justify-center gap-2 text-sm font-bold text-gold" data-id="element-113" data-mp="372je50jmyjr9">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-114" data-mp="10cbt5hb351es" />
        The promotional price expires in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-115" data-mp="15b68uadra9uo">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-116" data-mp="y0wuxmh0xyl0" data-mpi={i}>
            <div className="flex w-[72px] flex-col items-center" data-id="element-117" data-mp="xzvfl5sz6pxh">
              <span className="w-full rounded-xl bg-alert py-2 text-center font-display text-3xl font-black tabular-nums" data-id="element-118" data-mp="t2llhcun5q3b">
                {String(u.value).padStart(2, '0')}
              </span>
              <span className="mt-1 text-[11px] font-semibold uppercase tracking-wider text-slate-400" data-id="element-119" data-mp="12rd8d6kuhk7d">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="pt-2 font-display text-3xl font-black text-alert" data-id="element-120" data-mp="f4ev0hs0usdo">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}